var __jsx = React.createElement;
import React from 'react';
import TamaraFinanceScreen from './TamaraFinanceScreen';
var TamaraFinancePage = function TamaraFinancePage() {
  return /*#__PURE__*/React.createElement(TamaraFinanceScreen, null);
};
export default TamaraFinancePage;